import React from 'react';
import { Paper } from '@mui/material';

/**
 * Shared card wrapper for auth pages (Login, Register).
 * Keeps elevation, padding, and width consistent; theme controls borderRadius via MuiPaper.
 */
const AuthCard = ({ children, ...paperProps }) => (
    <Paper
        elevation={3}
        sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
        }}
        {...paperProps}
    >
        {children}
    </Paper>
);

export default AuthCard;
